
// ui/constants/complianceMappingTW.ts

export const DEPT_CODE_TO_NAME_TW: Record<string, string> = {
  "GM": "總經理室",
  "FA": "財務部",
  "AP": "行政人資部",
  "IT": "資訊部",
  "LG": "法務部",
  "SL": "業務部",
  "SL1": "業務一部",
  "SL2": "業務二部",
  "LI": "物流部",
  "PT": "採購部",
  "QC": "品保部",
  "MD": "行銷宣傳部",
  "AW": "行政倉儲部",
  "SP": "上友包裝部"
};

export const REGULATOR_MAPPING_TW: Record<string, {id: string, name: string}> = {
  "mol": { id: "mol", name: "勞動部" },
  "osha": { id: "osha", name: "勞動部職業安全衛生署" },
  "bli": { id: "bli", name: "勞動部勞工保險局" },
  "tfda": { id: "tfda", name: "衛生福利部食品藥物管理署" },
  "mohw": { id: "mohw", name: "衛生福利部" },
  "moenv": { id: "moenv", name: "環境部" },
  "pdpc": { id: "pdpc", name: "個人資料保護委員會籌備處" }, // Also covers NDC for now
  "customs": { id: "customs", name: "財政部關務署" },
  "baphiq": { id: "baphiq", name: "農業部動植物防疫檢疫署" },
  "boft": { id: "boft", name: "經濟部國際貿易署" },
  "fair": { id: "fair", name: "公平交易委員會" }
};

export const KEYWORD_RULES = [
    { keywords: ["食品", "食安", "查驗", "GHP", "追溯"], target: "tfda" },
    { keywords: ["職業安全", "職安", "設施標準", "防護"], target: "osha" },
    { keywords: ["勞工", "勞基法", "工資", "工時", "性別平等", "性騷擾"], target: "mol" },
    { keywords: ["勞保", "就保", "退休金"], target: "bli" },
    { keywords: ["個資", "個人資料"], target: "pdpc" },
    { keywords: ["廢棄物", "環保", "回收", "碳"], target: "moenv" },
    { keywords: ["關稅", "進口"], target: "customs" },
    { keywords: ["檢疫", "動植物"], target: "baphiq" }
];

export function getDeptNameTW(code?: string): string {
    if (!code) return "未設定";
    // If code is already Chinese, return it
    if (/[\u4e00-\u9fa5]/.test(code)) return code;
    return DEPT_CODE_TO_NAME_TW[code.toUpperCase()] || code;
}

export function getDeptNameByCode(code?: string | null): string {
  if (!code) return "未設定";
  if (/[\u4e00-\u9fa5]/.test(code)) return code;
  return DEPT_CODE_TO_NAME_TW[code.toUpperCase()] || code;
}

export function inferRegulatorTW(text: string, url?: string): { id: string, name: string, confidence: number } {
    const t = text.toLowerCase();
    const u = (url || "").toLowerCase();

    // 1. URL Strong Match
    if (u.includes("fda.gov.tw")) return { ...REGULATOR_MAPPING_TW.tfda, confidence: 0.95 };
    if (u.includes("osha.gov.tw")) return { ...REGULATOR_MAPPING_TW.osha, confidence: 0.95 };
    if (u.includes("mol.gov.tw")) return { ...REGULATOR_MAPPING_TW.mol, confidence: 0.95 };
    if (u.includes("moenv.gov.tw") || u.includes("epa.gov.tw")) return { ...REGULATOR_MAPPING_TW.moenv, confidence: 0.95 };
    if (u.includes("ndc.gov.tw") && t.includes("個資")) return { ...REGULATOR_MAPPING_TW.pdpc, confidence: 0.9 };

    // 2. Keyword Match
    for (const rule of KEYWORD_RULES) {
        if (rule.keywords.some(k => t.includes(k))) {
            return { ...REGULATOR_MAPPING_TW[rule.target], confidence: 0.75 };
        }
    }

    return { id: "", name: "待補齊", confidence: 0 };
}

